module.exports = __webpack_public_path__ + "static/media/eqra.27df40e1.png";